export default 'teamCalendarApp';
